module.exports = __webpack_public_path__ + "img/政策法规 手机端.efd85015.jpg";